export default {
    ParseJsonOrDefaultArray($jsonStr){
        if ($jsonStr===""){
            return [];
        }else{
            return JSON.parse($jsonStr);
        }
    },
    ParseJsonOrDefaultEmpty($jsonStr){
        if ($jsonStr===""){
            return "";
        }else{
            return JSON.parse($jsonStr);
        }
    },
    ParseJsonOrDefaultObject($jsonStr){
        if ($jsonStr===""){
            return {};
        }else{
            return JSON.parse($jsonStr);
        }
    },
    ParseJsonOrDefaultObjectWithTemplate($jsonStr,template){
        if ($jsonStr===""){
            return {...template};
        }else{
            return JSON.parse($jsonStr);
        }
    },
}
